import ShowEnquiryAnswers from './ShowEnquiryAnswers.component';

export default ShowEnquiryAnswers;
